const config = {
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
  NAME: process.env.REACT_APP_NAME as string,
  LOCALES: ['en', 'fr'],

  API_URL: process.env.REACT_APP_API_URL as string,
  API_TIMEOUT: 5000, // 5 seconds

  AUTH_KEEP_ALIVE_INTERVAL: 60000, // 1 minute
  AUTH_CREDENTIALS_STORAGE_KEY: 'auth',
  AUTH_REMEMBER_STORAGE_KEY: 'remember',

  BREAKPOINT_XS: 430,
  BREAKPOINT_SM: 767,
  BREAKPOINT_MD: 991,

  DEFAULT_COUNTRY: 'CM',
  DEFAULT_CURRENCY: 'XAF',
  DEFAULT_LOCALE: 'en',
  DEFAULT_PAGINATION_LIMIT: 10,

  DATE_FORMAT: 'DD.MM.YYYY',
  DATE_MONTH_FORMAT: 'DD MMM',
  DATE_TIME_FORMAT: 'DD.MM.YYYY, LT',

  FILTERS_QUERY_PARAM: 'filters',

  THEME_MESSAGE_MAX_COUNT: 3,
  THEME_NOTIFICATION_DURATION: 5, // 5 seconds
  THEME_NOTIFICATION_MAX_COUNT: 3,

  PRIVACY_URL: 'https://agglopay.com/privacy-policy',
  TERMS_URL: 'https://agglopay.com/terms-and-conditions',

  ACCOUNT_NUMBER_MIN_LENGTH: 1,
  ACCOUNT_NUMBER_MAX_LENGTH: 32,
  ADDRESS_MIN_LENGTH: 3,
  ADDRESS_MAX_LENGTH: 64,
  BANK_CODE_MIN_LENGTH: 3,
  BANK_CODE_MAX_LENGTH: 32,
  CARD_CODE_MIN_LENGTH: 3,
  CARD_CODE_MAX_LENGTH: 4,
  CARD_NUMBER_MIN_LENGTH: 15,
  CARD_NUMBER_MAX_LENGTH: 19,
  CITY_MIN_LENGTH: 3,
  CITY_MAX_LENGTH: 64,
  COMPANY_NAME_MIN_LENGTH: 3,
  COMPANY_NAME_MAX_LENGTH: 255,
  DASHBOARD_PAYMENTS_MAX_INTERVAL: 30, // days
  DASHBOARD_STATISTICS_INTERVAL: 30, // days
  EMAIL_MAX_LENGTH: 50,
  FILE_ALLOWED_EXTENSIONS: ['jpeg', 'jpg', 'png', 'pdf'],
  FILE_MAX_SIZE: 5242880, // 5 MB
  INVOICE_AMOUNT_MIN: 1,
  INVOICE_AMOUNT_MAX: 1000000,
  INVOICE_PURPOSE_MIN_LENGTH: 3,
  INVOICE_PURPOSE_MAX_LENGTH: 250,
  NAME_MIN_LENGTH: 3,
  NAME_MAX_LENGTH: 255,
  PAYMENT_OTP_LENGTH: 5,
  PAYMENT_PIN_LENGTH: 4,
  PAYMENT_PURPOSE_MAX_LENGTH: 255,
  PASSWORD_MIN_LENGTH: 8,
  PASSWORD_MAX_LENGTH: 256,
  PHONE_MIN_LENGTH: 5,
  PHONE_MAX_LENGTH: 15,
  STATE_MIN_LENGTH: 3,
  STATE_MAX_LENGTH: 16,
  VERIFICATION_CODE_LENGTH: 6,
  VERIFICATION_CODE_RESEND_TIME: 60, // 1 minute
  WITHDRAWAL_AMOUNT_MIN: 1000,
  ZIP_MAX_LENGTH: 12,

  COUNTRIES_QUERY_KEY: 'countries',
  FILES_QUERY_KEY: 'files',
  INVOICES_QUERY_KEY: 'invoices',
  INVOICE_QUERY_KEY: 'invoice',
  PAYMENT_STATUS_QUERY_KEY: 'payment.status',
  PAYMENT_STATUS_QUERY_INTERVAL: 3000, // 3 seconds
  PAYOUTS_QUERY_KEY: 'payouts',
  PROFILE_QUERY_KEY: 'profile',
  PROFILE_BALANCE_QUERY_KEY: 'profile.balance',
  STATISTICS_FEES_QUERY_KEY: 'statistics.fees',
  STATISTICS_PAYMENTS_QUERY_KEY: 'statistics.payments',
  STATISTICS_PAYOUTS_QUERY_KEY: 'statistics.payouts',
  STATISTICS_VOLUMES_QUERY_KEY: 'statistics.volumes',
  WITHDRAWAL_QUERY_KEY: 'withdrawal',
};

export default config;
